<template>
    <div id="contenedor-principal-bs-documentos" class="container-fluid">
        <div id="encabezados">
            <h1>BUSQUEDA DE DOCUMENTOS</h1>
            <h4>Busque el contenido de la página web y obtenga la informacion de sus documentos</h4>
            <div class="hr-titulo"></div>
        </div>
        <!-- SECCION DE FILTROS -->
        <div id="filtros-busqueda">
            <div class="titulo-contenedores">
                <h5 class="font-weight-bold"><i class="fas fa-search"></i>&nbsp;&nbsp;Filtros de búsqueda</h5>
            </div>
            <CFiltrosDeContenidos
                v-on:BusquedaContenidos="buscarContenidos"></CFiltrosDeContenidos>
        </div>
        <!-- TABLA DE CONTENIDOS -->
        <div style="margin-top: 5em;">
            <div class="titulo-contenedores">
                <h5 class="font-weight-bold"><i class="fas fa-list"></i>&nbsp;&nbsp;Listado de contenidos</h5>
            </div>
            <div id="contenedor-tabla-ds-documentos" class="container-fluid area">
                <div v-if="contenidos.documentosSeleccionados.length > 0" id="copia-multiple-url">
                    <button type="button" @click="copiarMultiplesUrlDeDocumentos" class="btn btn-light"><i class="fas fa-link"></i>&nbsp;&nbsp;Copiar url de documentos seleccionados</button>
                </div>
                <table
                    class="table table-striped table-light table-hover"
                    :id="contenidos.tabla.ID"              
                    data-toggle="table"
                    data-pagination="true"
                    data-undefined-text="Sin información"
                    data-maintain-selected="true"  
                    data-page-size = "5"
                    data-page-list="[5,10,20]"
                    data-click-to-select="false"
                    data-search="true">
                    <thead class="thead-green">
                        <tr>
                            <th data-halign="center" data-width="5" data-align="center" data-checkbox="true"></th>
                            <th data-halign="center" data-width="5" data-align="center" data-field="ArchivoDeContenidoDeLaPaginaWebId" data-sortable="true">
                                Id
                            </th>
                            <th data-halign="center" data-width="10" data-align="center" data-field="contenido.ContenidoDeLaPaginaWebId" data-sortable="true">
                                Id cont
                            </th>
                            <th data-events="operateEvents" data-halign="center" data-width="30" data-align="center" data-field="contenido.textoDescriptivo.texto" data-sortable="true">
                                Texto del contenido
                            </th>
                            <th data-halign="center" data-width="20" data-align="center" data-field="NombreBase" data-sortable="true">
                                Nombre doc
                            </th>
                            <th data-halign="center" data-width="10" data-align="center" data-field="extension" data-sortable="true">
                                Extension
                            </th>
                            <th data-events="operateEvents" data-width="15" :data-formatter="this.formateadorHTMLAcciones()" data-halign="center" data-align="center">
                                Acciones
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
        <!-- MODAL VISOR -->
      <!--   <VisorPDFV2 v-if="visorPdf.mostrar"
            :url="visorPdf.url"
            :key="'VDCSICPO' + visorPdf.contRender"></VisorPDFV2> -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visor-documentos">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Documento</h5>
                        <button id="btn-cerrar-visor-documentos" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4 pt-2 pb-4">
                        <div id="seccion-visor">
                            <!-- <PDFDocument 
                                :url="visorPdf.url" 
                                :ArchivoAConvertir="visorPdf.archivo"
                                :height="visorPdf.height"
                                :key="'VDCSICPO' + visorPdf.contRender" /> -->
                                <VisorPDFV2 
                                    :url="visorPdf.url"
                                    :porPaginas="true"
                                    :key="'VDCSICPO' + visorPdf.contRender"></VisorPDFV2>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CFiltrosDeContenidos from '@/components/SICPO/PaginaWeb/BusquedaDeDocumentos/CFiltrosDeContenidos.vue';
import enumeraciones from '@/../static/js/enumeraciones'
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import path from 'path';
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import VisorPDFV2 from '@/../src/components/Comunes/VisorPDFV2'

export default {
    components: {
        CFiltrosDeContenidos: CFiltrosDeContenidos,
        PDFDocument,
        VisorPDFV2
    },
    data() {
        return {
            enumeraciones_sicpo,
            contenidos: {
                lista: [],
                filtros: null,
                tabla: {
                    ID: 'tabla-busqueda-contenidos-bs-documento',
                    elementos: [],
                    cargoElementos: false
                },
                tipoAccion: null,
                documentoSeleccionado: null,
                documentosSeleccionados: []
            },
            TIPOS_ACCIONES: {
                DESCARGAR: 1,
                VISUALIZAR: 2
            },
            visorPdf: {
                url: null,
                height: '500px',
                archivo: null,
                contRender: 0,
                mostrar: false
            },
        }
    },
    methods: {
        copiarMultiplesUrlDeDocumentos: async function() {
            await Promise.resolve(this.concatenacionMultipleDeUrlDocumentos());
            $("#" + this.contenidos.tabla.ID).bootstrapTable('uncheckAll');
            this.contenidos.documentosSeleccionados = [];
        },
        concatenacionMultipleDeUrlDocumentos: async function() { debugger
            let copiaFinal = '';
            this.contenidos.documentosSeleccionados.forEach(d => {
                console.log('d::',d)
                if(new String(d.ArchivoDeContenidoDeLaPaginaWebId).includes('-c')) {
                    let archivoObj = {...d}
                    let rutaFormateada = archivoObj.contenido.RutaDeImagen;
                    if(rutaFormateada.includes("\\themisfs")) {
                        rutaFormateada = rutaFormateada.replace(/\\themisfs/g, enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos);
                        rutaFormateada = rutaFormateada.replace(/\\/g, "/");
                        rutaFormateada = rutaFormateada.substring(1); 
                    }
                    copiaFinal += rutaFormateada;
                    copiaFinal += "\n";
                }
                else if(this.campoRequeridoEsValido(d.RutaDelArchivo)) {
                    let archivoObj = {...d}
                    const { RutaDelArchivo } = archivoObj;
                    let rutaFormateada = RutaDelArchivo;
                    if(rutaFormateada.includes("\\themisfs")) {
                        rutaFormateada = RutaDelArchivo.replace(/\\themisfs/g, enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos);
                        rutaFormateada = rutaFormateada.replace(/\\/g, "/");
                        rutaFormateada = rutaFormateada.substring(1); 
                    }
                    copiaFinal += rutaFormateada;
                    copiaFinal += "\n";
                }
            });

            var $temp = $("<textarea>");

            $("body").append($temp);
            
            $temp.val(copiaFinal).select();
            document.execCommand("copy");
            $temp.remove();
        },
        descargarDocumento: function({ rutaDeDocumento }) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${ api.conexion }${ api.Comun.funcion.DescargarArchivo }?rutaDelArchivo=${ rutaDeDocumento }`
            a.click();
        },
        accionDetallesDeDocumento: async function({ tipo, contenido }) { debugger
            const { DESCARGAR, VISUALIZAR } = this.TIPOS_ACCIONES;
            this.contenidos.tipoAccion = await Promise.resolve(this.obtenerTipoDeAccion({ documento: contenido }));
            switch(this.contenidos.tipoAccion) { 
                case DESCARGAR: 
                    console.log('contenido.ArchivoDeContenidoDeLaPaginaWebId::',contenido.ArchivoDeContenidoDeLaPaginaWebId)
                    if(new String(contenido.ArchivoDeContenidoDeLaPaginaWebId).includes('-c'))
                        this.descargarDocumento({ rutaDeDocumento: contenido.contenido.RutaDeImagen });
                    else
                        this.descargarDocumento({ rutaDeDocumento: contenido.RutaDelArchivo });
                    break;
                case VISUALIZAR: 
                    this.visorPdf.url = contenido.RutaDelArchivo;
                    this.visorPdf.contRender ++;
                    $("#visor-documentos").modal('show');
                    this.visorPdf.mostrar = true;
                    break;
                default: 
                    break;
            }
        },
        obtenerTipoDeAccion: async function({ documento }) { 
            const { DESCARGAR, VISUALIZAR } = this.TIPOS_ACCIONES;
            let accion = null;
            let extensionDocumento = path.extname(documento.RutaDelArchivo);
            console.log('EXTENSION::',extensionDocumento);
            if(extensionDocumento.toUpperCase() == '.PDF' || extensionDocumento.toUpperCase() == '.DOC' || extensionDocumento.toUpperCase() == '.DOCX')
                accion = VISUALIZAR;
            else
                accion = DESCARGAR;

            return accion;
        },
        acortarTextoEnCelda: function({ contenido }) { 
            let texto = '-';
            let tieneTexto = false;
            const TEXTO_DE_CONTENIDO = (this.campoRequeridoEsValido(contenido.TextoDelContenido)) ? contenido.TextoDelContenido : contenido.TextoDelVinculo;
            if(this.campoRequeridoEsValido(TEXTO_DE_CONTENIDO)) {
                // si el texto del contenido es muy largo lo corta, numMax caracteres = 13
                texto = (TEXTO_DE_CONTENIDO.length > 45) ? TEXTO_DE_CONTENIDO.substring(0,44) : TEXTO_DE_CONTENIDO; 
                tieneTexto = true;
            } 
            return (tieneTexto && TEXTO_DE_CONTENIDO.length > 45) ? `${ texto }&nbsp;&nbsp;&nbsp;<i id="${ contenido.ContenidoDeLaPaginaWebId }-i-ampliarContenido" style="cursor: pointer;" class="icono-ampliar-texto fas fa-caret-down"></i>` : texto;
        },
        mostrarTextoDeContenidoCompleto: function(contenidoRow, indexColumna) { debugger
            console.log('contenidoRow::',contenidoRow);
            let contenidoObj = this.contenidos.tabla.elementos.find(c => c.ArchivoDeContenidoDeLaPaginaWebId == contenidoRow.ArchivoDeContenidoDeLaPaginaWebId);
            if(this.campoRequeridoEsValido(contenidoObj)) {
                const CONTENIDO_OBJ_COMPLETO = this.contenidos.lista.find(c => c.ContenidoDeLaPaginaWebId == contenidoObj.contenido.ContenidoDeLaPaginaWebId);
                if(this.campoRequeridoEsValido(CONTENIDO_OBJ_COMPLETO)) {
                    if(!contenidoObj.contenido.textoDescriptivo.mostrarTextoCompleto) {
                        contenidoObj.contenido.textoDescriptivo.texto = (this.campoRequeridoEsValido(CONTENIDO_OBJ_COMPLETO.TextoDelContenido)) ? CONTENIDO_OBJ_COMPLETO.TextoDelContenido + `&nbsp;&nbsp;&nbsp;<i id="${ contenidoObj.ArchivoDeContenidoDeLaPaginaWebId }-i-ampliarContenido" style="cursor: pointer;" class="icono-ampliar-texto fas fa-caret-up"></i>`
                        : CONTENIDO_OBJ_COMPLETO.TextoDelVinculo + `&nbsp;&nbsp;&nbsp;<i id="${ contenidoObj.ArchivoDeContenidoDeLaPaginaWebId }-i-ampliarContenido" style="cursor: pointer;" class="icono-ampliar-texto fas fa-caret-up"></i>`;
                        contenidoObj.contenido.textoDescriptivo.mostrarTextoCompleto = true;
                    }
                    else {
                        contenidoObj.contenido.textoDescriptivo.texto = this.acortarTextoEnCelda({ contenido: CONTENIDO_OBJ_COMPLETO }),
                        contenidoObj.contenido.textoDescriptivo.mostrarTextoCompleto = false;
                    }

                    /* MEJOR ACTUALIZAR POR ID PARA NO DUPLICAR REGISTROS CUANDO SE UTILIZA EL DATA SEARCH */
                    $("#" + this.contenidos.tabla.ID).bootstrapTable('updateByUniqueId', {
                        id: contenidoObj.ArchivoDeContenidoDeLaPaginaWebId,
                        row: contenidoObj
                    });
                }
            }
        },
        buscarContenidos: async function(filtrosDeBusqueda) {
            this.contenidos.filtros = filtrosDeBusqueda;
            const PETICION_GET_DOCUMENTOS = await Promise.resolve(this.construirPeticionBusquedaDeDocumentos());
            await Promise.resolve(this.buscarDocumentosDeContenidosBD({ peticion: PETICION_GET_DOCUMENTOS }));
        },
        construirPeticionBusquedaDeDocumentos: async function() {
            const { paginaWebId, secccionId, fechaInicial, textoContenido } = this.contenidos.filtros;
            let peticion = {};
            peticion.PalabraEnTextoDelContenido = textoContenido;
            peticion.PaginaWebId = paginaWebId;
            peticion.SeccionDeLaPaginaWebId = secccionId;
            peticion.FechaRegistro = fechaInicial;
            peticion.ConArchivosInactivos = false;
            peticion.esPrueba = false;
            return peticion;
        },
        buscarDocumentosDeContenidosBD: async function({ peticion }) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.paginaweb.busquedadedocumentos.GetDocumentosContenidosPaginaWeb;;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_BUSQUEDA_DOCUMENTOS = await axios.post(urlApi, peticion, headerPeticion);
                const DATOS_PETICION = await PETICION_BUSQUEDA_DOCUMENTOS.data;
                let { SiHayError, Error, Satisfactorio, contenidosDeLaPaginaWeb } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    console.log('contenidosDeLaPaginaWeb::',contenidosDeLaPaginaWeb);
                    comun.SeEstaCargandoInformacion(false);
                    this.contenidos.lista = (this.campoRequeridoEsValido(contenidosDeLaPaginaWeb) && contenidosDeLaPaginaWeb.length > 0) ? contenidosDeLaPaginaWeb : [];
                    await Promise.resolve(this.inicializarTabla({ elementos: contenidosDeLaPaginaWeb }));
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        formateadorHTMLAcciones: () => {
            return [
            '<div>',
                '<button id="btn-info-contenido-vbdd" type="button" class="btn btn-light btn-sm btn-xs btn-lg btn-md mr-2"><i class="fas fa-info"></i>&nbsp;&nbsp;Detalles</button>',
                '<button id="btn-url-contenido-vbdd" title="copiar" type="button" class="btn btn-light btn-sm btn-xs btn-lg btn-md"><i class="fas fa-link"></i></button>',
            '</div>'
            ].join("");
        },
        formateadorHTMLAccionesDocumentos: () => {
            return [
            '<div>',
                '<button id="btn-info-documento-vbdd" type="button" class="btn btn-light btn-sm btn-xs btn-lg btn-md mr-2"><i class="fas fa-info"></i>&nbsp;&nbsp;Detalles</button>',
                '<button id="btn-url-documento-vbdd" title="copiar" type="button" class="btn btn-light btn-sm btn-xs btn-lg btn-md"><i class="fas fa-link"></i></button>',
            '</div>'
            ].join("");
        },
        darFormatoObjetosDeContenido: async function({ elementos }) {
            this.contenidos.tabla.elementos = elementos.map(c => {
                let contenidoObj = {...c};
                contenidoObj.textoDescriptivo = {
                    texto: this.acortarTextoEnCelda({ contenido: c }),
                    mostrarTextoCompleto: false
                };
                contenidoObj.numeroDocumentos = contenidoObj.ArchivosDeContenidoDeLaPaginaWeb.length;
                return contenidoObj;
            })
        },
        obtenerNombreDocumento: function(documento) {
            let base = new String(documento).substring(documento.lastIndexOf('\\') + 1); 
                if(base.lastIndexOf(".") != -1)       
                    base = base.substring(0, base.lastIndexOf("."));
            return base;
        },
        darFormatoObjetosDeContenidoDos: async function({ elementos }) {
            let documentos = [];
            if(this.campoRequeridoEsValido(elementos) && elementos.length > 0)
                elementos.forEach(contenido => {
                    // IMAGENES DE CONTENIDO
                    if(this.campoRequeridoEsValido(contenido.RutaDeImagen)) {
                        let documentoObj = {};
                        documentoObj.NombreBase = this.obtenerNombreDocumento(contenido.RutaDeImagen);
                        documentoObj.ArchivoDeContenidoDeLaPaginaWebId = contenido.ContenidoDeLaPaginaWebId + '-c';
                        documentoObj.contenido = {...contenido};
                        documentoObj.contenido.textoDescriptivo = {
                            texto: this.acortarTextoEnCelda({ contenido: contenido }),
                            mostrarTextoCompleto: false
                        };
                        let extension = path.extname(contenido.RutaDeImagen);
                        let colorExtension = this.obtenerColorDeExtension(extension);
                        documentoObj.extension =`<div style="display: flex; text-align: center; justify-content: center;" class="pb-1">
                                                    <div style="background-color: ${ colorExtension }; color: black; width: max-content; border-radius: 0.5em; padding: 0.5vmin 2vmin 0vmin 2vmin;">
                                                        <h6 style="font-weight: bold; font-size: 2vmin;">${ extension }</h6>
                                                    </div>
                                                    </div>`;
                        documentos.push(documentoObj)
                    }
                    // ARCHIVOS DE CONTENIDO
                    contenido.ArchivosDeContenidoDeLaPaginaWeb.forEach(a => {
                        let documentoObj = {...a};
                        documentoObj.contenido = {...contenido}
                        documentoObj.contenido.textoDescriptivo = {
                            texto: this.acortarTextoEnCelda({ contenido: contenido }),
                            mostrarTextoCompleto: false
                        };
                        let extension = path.extname(a.RutaDelArchivo);
                        let colorExtension = this.obtenerColorDeExtension(extension);
                        documentoObj.extension =`<div style="display: flex; text-align: center; justify-content: center;" class="pb-1">
                                                    <div style="background-color: ${ colorExtension }; color: black; width: max-content; border-radius: 0.5em; padding: 0.5vmin 2vmin 0vmin 2vmin;">
                                                        <h6 style="font-weight: bold; font-size: 2vmin;">${ extension }</h6>
                                                    </div>
                                                </div>`;
                        documentos.push(documentoObj)
                    })
                })
            this.contenidos.tabla.elementos = documentos;
            console.log('this.contenidos.tabla.elementos::',this.contenidos.tabla.elementos);
        },
        obtenerColorDeExtension: function(extension) {
            let color = '#ECE6E6';
            switch(extension.toUpperCase()) {
                case '.PDF':
                    color = '#9c5757';
                break;
                case '.DOC':
                    color = '#354b74';
                break;
                case '.DOCX':
                    color = '#354b74';
                break;
                default:
                    color = '#caca9f';
                break;
            }
            return color;
        },
        darFormatoObjetosDeArchivos: async function({ elementos }) {
            this.contenidos.documentos.lista = elementos.map(a => {
                let archivoObj = {...a};
                archivoObj.extension = path.extname(a.RutaDelArchivo);
                return archivoObj;
            })
        },
        inicializarTablaArchivos: async function({ elementos }) { 
            await Promise.resolve(this.darFormatoObjetosDeArchivos({ elementos: elementos }));
            this.$nextTick(() => {
                $("#" + this.contenidos.documentos.ID).bootstrapTable({  data: this.contenidos.documentos.lista });      
                $("#" + this.contenidos.documentos.ID).bootstrapTable('load', this.contenidos.documentos.lista ); 
            });
        },
        evtSeleccionoDocumento: function(e, row) {
            const ID_ARCHIVO = row.ArchivoDeContenidoDeLaPaginaWebId;
            if(!this.contenidos.documentosSeleccionados.some(d => d.ArchivoDeContenidoDeLaPaginaWebId == ID_ARCHIVO)) {
                const DOCUMENTO = this.contenidos.tabla.elementos.find(a => a.ArchivoDeContenidoDeLaPaginaWebId == ID_ARCHIVO);
                this.contenidos.documentosSeleccionados.push(DOCUMENTO);
            }
        },
        evtRemoverDocumentosEnListaDeSeleccionados: function(e, rows, tipoCheck) { 
            switch(tipoCheck) {
                case 'UNO':
                    this.contenidos.documentosSeleccionados = this.contenidos.documentosSeleccionados.filter(a => a.ArchivoDeContenidoDeLaPaginaWebId != rows.ArchivoDeContenidoDeLaPaginaWebId);
                    break;
                case 'MUCHOS':
                    if(this.campoRequeridoEsValido(rows))
                        // se remueven la paginacion de archivos seleccionados
                        this.contenidos.documentosSeleccionados = this.contenidos.documentosSeleccionados.filter(a => {
                            return !rows.some(ar => {
                                return a.ArchivoDeContenidoDeLaPaginaWebId == ar.ArchivoDeContenidoDeLaPaginaWebId;
                            });
                        });
                    else
                        this.contenidos.documentosSeleccionados = [];
                    break;
                default:
                    break;
            }
        },
        evtSeleccionoTodos: function(e, rows) {
            this.contenidos.documentosSeleccionados = rows;
        },
        inicializarTabla: async function({ elementos }) { 
            await Promise.resolve(this.darFormatoObjetosDeContenidoDos({ elementos: elementos }));
            this.$nextTick(() => {
                $("#" + this.contenidos.tabla.ID).bootstrapTable({  data: this.contenidos.tabla.elementos });      
                $("#" + this.contenidos.tabla.ID).bootstrapTable('load', this.contenidos.tabla.elementos ); 
                // EVENTOS
                $("#" + this.contenidos.tabla.ID).off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table page-change.bs.table sort.bs.table");
                $("#" + this.contenidos.tabla.ID).on('check.bs.table',(e, row) => {
                    this.evtSeleccionoDocumento(e, row);
                });
                $("#" + this.contenidos.tabla.ID).on('uncheck.bs.table',(e, row) => {
                    const TIPO_CHECK = 'UNO';
                    this.evtRemoverDocumentosEnListaDeSeleccionados(e, row,TIPO_CHECK);
                });
                $("#" + this.contenidos.tabla.ID).on('check-all.bs.table',(e, rows) => {
                    this.evtSeleccionoTodos(e, rows);
                });
                $("#" + this.contenidos.tabla.ID).on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
                    const TIPO_CHECK = 'MUCHOS';
                    this.evtRemoverDocumentosEnListaDeSeleccionados(e, rowsBefore,TIPO_CHECK);
                });
            });
        },
        copiarUrlDeArchivosDelContenido: function({ evento, contenido }) { debugger
            let urlArchivos = [];
            let copiaFinal = '';
            if(new String(contenido.ArchivoDeContenidoDeLaPaginaWebId).includes('-c')) {
                let archivoObj = {...contenido}
                let rutaFormateada = archivoObj.contenido.RutaDeImagen;
                if(rutaFormateada.includes("\\themisfs")) {
                    rutaFormateada = rutaFormateada.replace(/\\themisfs/g, enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos);
                    rutaFormateada = rutaFormateada.replace(/\\/g, "/");
                    rutaFormateada = rutaFormateada.substring(1); 
                }
                urlArchivos.push(rutaFormateada);
            }
            else if(this.campoRequeridoEsValido(contenido.RutaDelArchivo)) {
                let archivoObj = {...contenido}
                const { RutaDelArchivo } = archivoObj;
                let rutaFormateada = RutaDelArchivo;
                if(rutaFormateada.includes("\\themisfs")) {
                    rutaFormateada = RutaDelArchivo.replace(/\\themisfs/g, enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos);
                    rutaFormateada = rutaFormateada.replace(/\\/g, "/");
                    rutaFormateada = rutaFormateada.substring(1); 
                }
                urlArchivos.push(rutaFormateada);
            }

            if(urlArchivos.length > 0)
                copiaFinal = urlArchivos.join('\n');

            var aux = document.createElement("input");
            aux.setAttribute("value",copiaFinal);
            document.body.appendChild(aux);
            aux.select();
            document.execCommand("copy");
            document.body.removeChild(aux);
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    mounted() {
        this.inicializarTabla({ elementos: [] });
        window.operateEvents = {
            "click #btn-info-contenido-vbdd": (e,val,row,index) => {         
                this.accionDetallesDeDocumento({ contenido: row });
            },
            "click #btn-url-contenido-vbdd": (e,val,row,index) => {          
                this.copiarUrlDeArchivosDelContenido({ contenido: row });
            },
            'click .icono-ampliar-texto': (e, value, row, index) => { 
                this.mostrarTextoDeContenidoCompleto(row, index);
            },
        };
    }
}
</script>
<style scoped>
.thead-green{
    background-color: var(--verde-pj-100);
    color: white;
}
#seccion-visor {
    padding: 0 10% 0 10%;
}

#visor-documentos .modal-lg {
    max-width: 80% !important;
}

#visor-documentos .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#encabezados {
    margin-bottom: 4em;
}

#encabezados h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados h4 {
    font-size: 1.5em;
    
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:var(--verde-pj);
}

.titulo-contenedores {
    background-color: var(--verde-pj);
    padding: 1.3em 2em 0.5em 2em;
}
</style>
<style>
#contenedor-tabla-ds-documentos .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 50vmin;
}

#contenedor-tabla-ds-documentos{
    background-color: var(--gris-pj-100);
    border: .2em solid  var(--gris-pj);
}
#contenedor-tabla-ds-documentos td {
    background-color: rgb(238, 238, 238);
    vertical-align: middle;
}

.borderless td, .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

#contenedor-tabla-ds-documentos .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #AF9C9C;
    font-size: 1em;
}

#contenedor-tabla-ds-documentos .btn-light:hover, #contenedor-tabla-ds-documentos .btn-light:focus {
    background-color: #4F4949;
    border: 1px solid #4F4949;
    color: white;
}

#contenedor-tabla-ds-documentos table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

#contenedor-tabla-ds-documentos .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

#contenedor-tabla-ds-documentos .pagination > li > a {
    background-color: white;
    color: #121213;
}

#contenedor-tabla-ds-documentos .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

#contenedor-tabla-ds-documentos > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
} 
</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/BusquedaDeDocumentos/CDocumentosDeContenidos.vue